// extracted by mini-css-extract-plugin
module.exports = {"typography":"portableText_typography__S8q5x","lineBreak":"portableText_lineBreak__isMGD"};